import React, { useState } from "react";
import { useMutation } from "@apollo/client";
//import bcrypt from "bcryptjs";
import { CREATE_ORGAN, ALL_ORGANS } from "../queries";
//import { useParams } from "react-router-dom";
import { TextField, Button, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}

*/
import ReCAPTCHA from "react-google-recaptcha";
//import { get } from "lodash";
/* eslint-disable react/prop-types */
const OrganForm = ({ setError }) => {
  // eslint-disable-next-line;
  const [t] = useTranslation("common");
  //const [id, setId] = useState(null)
  // eslint-disable-next-line
  const [organ] = useState(null);
  //console.log(organ);
  const [organname, setName] = useState("");
  const [organshort, setShort] = useState("");
  const [organurl, setUrl] = useState("");
  const [organmunicipality, setMunicipality] = useState("");
  const [system, setSystem] = useState("");
  //const [active, setActive] = useState(true)
  const [domain, setDomain] = useState("");
  //const [organname, setName] = useState("")
  //const [organshort, setShort] = useState("")
  //const [organurl, setUrl] = useState("")
  //const [organmunicipality, setMunicipality] = useState("")
  //const [system, setSystem] = useState("")
  //const [domain, setDomain] = useState("")
  // eslint-disable-next-line
  //const [t, i18n] = useTranslation("common")
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  // eslint-disable-next-line
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  //console.log(setVerified);
  //console.log(setSubmitted);
  // eslint-disable-next-line
  //const [getOrgan, result] = useLazyQuery(FIND_ORGAN);
  ////console.log(getOrgan);
  const [createOrgan] = useMutation(CREATE_ORGAN, {
    refetchQueries: [{ query: ALL_ORGANS }],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  //const [deleteOrgan] = useMutation(DELETE_ORGAN, {
  //refetchQueries: [{ query: ALL_ORGANS }],
  //onError: (error) => {
  ////console.log(error);
  //setError(error.graphQLErrors[0].message)
  //setError("virhe");
  //},
  /*update: (store, response) => {
  updateCacheWith(response.data.addComment)
  }*/
  //});
  /*useEffect(() => {
    if (result.data) {
      setOrgan(result.data.findOrgan);
    }
  }, [result.data]);
  */
  const submit = async () => {
    createOrgan({
      variables: {
        organname: organname,
        organshort: organshort,
        organmunicipality: organmunicipality,
        organurl: organurl,
        system: system,
        domain: domain,
      },
    });
  };

  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  //const setDelete = async (event) => {
  //event.preventDefault()
  ////console.log(event)
  //deleteOrgan({
  //variables: { id:event }
  //})

  //muutetaan activated !actived edituser
  //}
  // eslint-disable-next-line;
  /*onst stylea = {
    background: "white",
    opacity: 0.9
  };*/
  //useEffect(() => {;
  // setSectionid(sectionss);
  //}, []);
  if (submitted) {
    return (
      <div>
        <h2>{t("headers.addcommentorinformation")}</h2>
        {t("common.formok")}
        <br />
      </div>
    );
  } else {
    return (
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <form onSubmit={submit}>
                <div>
                  {t("common.name")}
                  <TextField value={organname} onChange={({ target }) => setName(target.value)} />
                </div>
                <br />
                <div>
                  {t("common.abbreviation")}
                  <TextField value={organshort} onChange={({ target }) => setShort(target.value)} />
                </div>
                <br />
                <div>
                  {t("common.municipal")}
                  <TextField
                    value={organmunicipality}
                    onChange={({ target }) => setMunicipality(target.value)}
                  />
                </div>
                <br />
                <div>
                  Url
                  <TextField value={organurl} onChange={({ target }) => setUrl(target.value)} />
                </div>
                <br />
                <div>
                  Domain
                  <TextField value={domain} onChange={({ target }) => setDomain(target.value)} />
                </div>
                <br />
                <div>
                  System
                  <Select
                    labelId="gender"
                    id="gender"
                    value={system}
                    onChange={({ target }) => setSystem(target.value)}
                  >
                    <MenuItem value={"ei valitt"}>ei valittu</MenuItem>
                    <MenuItem value={"CaseM"}>CaseM</MenuItem>
                    <MenuItem value={"Dynasty"}>Dynasty</MenuItem>
                    <MenuItem value={"Tweb"}>Tweb</MenuItem>
                  </Select>
                </div>
                <br />
                <div>
                  <ReCAPTCHA
                    sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                    onChange={onChange}
                  />
                </div>
                <br />
                <br />
                <Button
                  style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                  type="submit"
                  disabled={!verified}
                  executing={executing}
                  submitted={submitted}
                >
                  {submitted ? t("common.done") : executing ? "Verifying" : t("common.save")}
                </Button>
                <br />
                <br />
              </form>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    );
  }
};

export default OrganForm;
